/** @jsxImportSource @emotion/react */
import { Box, Heading, Text } from 'grommet'

import PlanGrid from './PlanGrid'
import useCreatedGroups from 'hooks/useCreatedGroups'

type Props = {
  productIdLoading?: string | false
  handleCheckout?: (product: string) => void | Promise<void>
}
export default function ComparePlans({ handleCheckout, productIdLoading = false }: Props) {
  const createdGroups = useCreatedGroups()

  return (
    <>
      <Box gap="medium" margin={{ top: 'large', bottom: 'medium' }}>
        <Text size="1.5rem" textAlign="center">
          {`You have already created ${createdGroups} groups for free. Good job!`}
        </Text>
        <Text size="1.5rem" textAlign="center">
          {
            "To continue improving your group's emotional intelligence, you can subscribe to an account."
          }
        </Text>
      </Box>
      <Heading fill margin={{ top: 'large', bottom: 'medium' }} textAlign="center" size="2.5rem">
        {'One Simple Pricing, all the benefits'}
      </Heading>
      <Box margin={{ vertical: 'medium' }} />
      <PlanGrid handleCheckout={handleCheckout} productIdLoading={productIdLoading} />
      <Box margin={{ vertical: 'medium' }} />
    </>
  )
}
